class CopyPaster {
    constructor(key) {
        this.key = key;
    }

    copy (value) {
        localStorage.setItem(this.key, JSON.stringify(value));
    }

    paste () {
        return JSON.parse(localStorage.getItem(this.key));
    }
}

export default CopyPaster;
